/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { REDUX_MSG_REQUEST_BO_STREAM_START } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_START_STREAM } from './types/common';

const sendStreamStartRequest: (distributorId: string, streamId: number, signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (distributorId, streamId, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<void> => {
    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, distributorId, BO_API_START_STREAM);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_STREAM_START, {
      ...requestDetails,
      signal,
      streamId,
    });
  };

export default sendStreamStartRequest;
